import { render, staticRenderFns } from "./contact_agent_info.vue?vue&type=template&id=52f55822&scoped=true"
import script from "./contact_agent_info.vue?vue&type=script&lang=js"
export * from "./contact_agent_info.vue?vue&type=script&lang=js"
import style0 from "./contact_agent_info.vue?vue&type=style&index=0&id=52f55822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f55822",
  null
  
)

export default component.exports